import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { getApiLanguageCode, type SupportedLocale } from '@/lib/i18nLocale';

/**
 * 푸터·i18n과 동기화된 API `language` 코드 (쿼리 파라미터·요청 바디용).
 */
export function useApiLanguage(): SupportedLocale {
	const { i18n } = useTranslation();
	return useMemo(() => getApiLanguageCode(i18n.language), [i18n.language]);
}
